import React from 'react'

const Layers = ({ lightColor, darkColor, circleColor }) => {
  const lightFill = lightColor ? lightColor : '#A0AEC0'
  const darkFill = darkColor ? darkColor : '#4A5568'
  const circleFill = circleColor ? circleColor : '#EDF2F7'

  return (
    <svg width="56" height="56" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <circle fill={circleFill} cx="28" cy="28" r="28" />
        <g fillRule="nonzero">
          <path
            d="M15.78 20.317l11.7-5.2a1.3 1.3 0 0 1 1.04 0l11.7 5.2a1.3 1.3 0 0 1 0 2.366l-11.7 5.2a1.3 1.3 0 0 1-1.04 0l-11.7-5.2a1.3 1.3 0 0 1 0-2.366z"
            fill={lightFill}
          />
          <path
            d="M17.483 26.05l9.984 4.433a1.3 1.3 0 0 0 1.066 0l9.984-4.433 1.716.767a1.3 1.3 0 0 1 0 2.366l-11.7 5.2a1.3 1.3 0 0 1-1.066 0l-11.7-5.2a1.3 1.3 0 0 1 0-2.366l1.716-.767zm0 6.5l9.984 4.433a1.3 1.3 0 0 0 1.066 0l9.984-4.433 1.716.767a1.3 1.3 0 0 1 0 2.366l-11.7 5.2a1.3 1.3 0 0 1-1.066 0l-11.7-5.2a1.3 1.3 0 0 1 0-2.366l1.716-.767z"
            fill={darkFill}
          />
        </g>
      </g>
    </svg>
  )
}

export default Layers
